import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpRequest } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    public readonly loadingObservable: BehaviorSubject<boolean> = new BehaviorSubject(false);

    private queue: HttpRequest<any>[] = [];

    public firstLoading = true;

    queueRequest(req: HttpRequest<any>) {
        if (!this.loadingObservable.getValue()) {
            this.loadingObservable.next(true);
        }
        this.queue.push(req);
    }

    removeFromQueue(req: HttpRequest<any>) {
        this.queue.splice(this.queue.indexOf(req), 1);
        if (!this.queue.length) {
            this.loadingObservable.next(false);
            this.firstLoading = false;
        }
        return this.loadingObservable;
    }
}
